
document.addEventListener('DOMContentLoaded',()=>{
  const menu=document.querySelector('[data-menu-button]');
  const nav=document.querySelector('[data-mobile-nav]');
  if(menu&&nav){menu.addEventListener('click',()=>nav.classList.toggle('open'));}
  document.querySelectorAll('[data-quantity]').forEach(w=>{
    const input=w.querySelector('input'), buttons=w.querySelectorAll('button');
    buttons.forEach(b=>b.addEventListener('click',()=>{
      let v=parseInt(input.value||1,10); v += b.dataset.action==='plus'?1:-1; v=Math.max(1,v); input.value=v;
    }));
  });
});

(function(){
  function sizeTopStack(){
    const announcement=document.querySelector('.announcement');
    const header=document.querySelector('.site-header, .header, .header-wrap, .sticky-header');
    if(!announcement || !header) return;
    const announcementHeight=announcement.offsetHeight;
    const headerHeight=header.offsetHeight;
    document.documentElement.style.setProperty('--announcement-height', announcementHeight+'px');
    document.documentElement.style.setProperty('--top-stack-height', (announcementHeight+headerHeight)+'px');
  }
  window.addEventListener('load', sizeTopStack);
  window.addEventListener('resize', sizeTopStack);
  document.addEventListener('DOMContentLoaded', sizeTopStack);
})();
